import { useContext, useEffect, useState } from 'react';
import { RiMapPinUserLine } from "react-icons/ri";
import AppMenu from '../constants/AppMenu';
import SiteThemeProvider from '../context/SiteThemeProvider';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import AuthContext from '../context/AuthContext';
import { resetSeialKey, useOnce } from '../helpers/submitDataOnServer';
import { useLanguage } from '../context/LanguageProvider';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const AppHeader = ({data}: {data: any}) => {
    const { SOFTWARE_ORG, SET_FULL_SOFT_DATA } = useSelector((state: RootState) => state.software);
    const [colorTheme, toggleTheme] = SiteThemeProvider();
    const toggleDarkMode = () => {
        toggleTheme();
    };

    useEffect(() => {
        document.documentElement.classList.toggle('dark', colorTheme === 'dark');
    }, [colorTheme]);

    const authContext = useContext(AuthContext);
    if (!authContext) {
        throw new Error('AuthContext must be used within an AuthProvider');
    }
    const { logoutUser } = authContext;
    const callResetSerialKey = useOnce(resetSeialKey);
    const [onOpenPassword, setOnPassword] = useState(false);
    const openPassword = () => {
        setOnPassword(true);
    }
    // Language context with TypeScript
    const { language, changeLanguage } = useLanguage();
    const handleLanguageChange = () => {
        changeLanguage(language === 'Eng' ? 'Nep' : 'Eng');
    };
    return (
        <div className='bg-gray-100 dark:bg-sky_850 w-full px-4 pt-1.5 top-0 sticky z-50'>
            <div className='flex justify-between'>
                <h6 className='font-public-sans font-semibold text-[14px] text-green-700'>{SET_FULL_SOFT_DATA?.today_np}</h6>
                <div className="bg-green-700 border-[1px] border-dotted shadow-lg px-1 py-0.5 my-auto rounded-sm hidden md:flex sm:hidden lg:flex 2xl:flex xl:flex">
                    <h6 className="jersey-20-charted-regular border border-dashed rounded-sm border-green-400 font-semibold py-0.5 px-5 text-white text-sm">
                        {language === 'Eng' ? SOFTWARE_ORG?.org?.org_name : SOFTWARE_ORG?.org?.org_name_nep}
                    </h6>
                </div>
                <div className='flex flex-row gap-3'>
                    <div className='me-3 flex gap-2'>
                        <div className="relative text-left hidden sm:block">
                            <div className="relative me-3">
                                <div onClick={handleLanguageChange} className="relative inline-flex select-none items-center justify-center w-7 h-7 overflow-hidden rounded-full bg-gray-300 dark:text-white text-black cursor-pointer dark:bg-gray-600">
                                    <h6 className='text-[12px]'>{language === 'Eng' ? 'EN' : 'NP'}</h6>
                                </div>
                            </div>
                        </div>
                        <div className="relative inline-flex items-center justify-center w-7 h-7 overflow-hidden rounded-full bg-gray-300 cursor-pointer dark:bg-gray-600">
                            <span className="font-sm text-green-800 border-gray-700 dark:text-gray-300">
                                <DarkModeSwitch checked={colorTheme === 'dark'} onChange={toggleDarkMode} size={15} />
                            </span>
                        </div>
                    </div>
                    <AppMenu label={`${data?.user_data?.first_name} ${data?.user_data?.last_name}`} openPassword={openPassword} resetSerialKey={callResetSerialKey} logoutUser={logoutUser} icon={<RiMapPinUserLine className='mr-1' />} />
                </div>
            </div>
        </div>
    );
};

export default AppHeader;
